app.service('eastMessage', function(account, console, log) {
	var isInit = false,
		text, expanded, timeout = null, userLanguage, isDataLayerOpenSent = false;
	var $self, $eastMessageToggleButton, $callButton, $learnMoreLink;

	function setEvents() {
		$self.mouseover(function() {
			show();
		}).mouseout(function() {
			hide();
		});
		$eastMessageToggleButton.on('keydown', function(e) {
			if (e.key === ' ' || e.key === 'Enter') {
				e.preventDefault();
				e.stopPropagation();
				show();
			}
		});
		$('body').on('focusin', function(e) { // obsługa zamykania warstwy po wyjściu z niej za pomocą klawiatury
			if (isOpen()) {
				if (!$(e.target).closest($self).length) {
					hide();
				}
			}
		}).on('keyup', function(e) {
			if (e.key === 'Escape') {
				if (isOpen()) {
					hide();
					$eastMessageToggleButton.focus();
				}
			}
		});
		$callButton.on('click', function() {
			log.event({
				'id': 'east_european_customer_call',
				'f03': document.location.pathname,
				'f04': userLanguage,
			});
			UA.push({
				event: 'button_click',
				buttonName: 'call_us',
				eventCategory: userLanguage, //'ua'|'ru'|'by' w zależności od języka
				eventLabel: 'tax_free_widget'
			});
		});
		$learnMoreLink.on('click', function() {
			log.event({
				'id': 'east_european_more_info',
				'f03': document.location.pathname,
				'f04': userLanguage,
			});
			UA.push({
				event: 'button_click',
				buttonName: 'check_details',
				eventCategory: userLanguage, //'ua'|'ru'|'by' w zależności od języka
				eventLabel: 'tax_free_widget'
			});
		});

	}

	function removeTimeout() {
		if (timeout !== null) {
			clearTimeout(timeout);
		}
	}

	function isOpen() {
		return $self.hasClass('show-message');
	}

	function show() {
		$self.addClass('show-message');
		$eastMessageToggleButton.attr('aria-expanded', 'true');
		$callButton.attr('tabindex', '0');
		$learnMoreLink.attr('tabindex', '0');
		removeTimeout();
		if (!isDataLayerOpenSent) {
			isDataLayerOpenSent = true;
			UA.push({
				event: 'expand',
				eventCategory: userLanguage, //'ua'|'ru'|'by' w zależności od języka
				eventLabel: 'tax_free_widget'
			});
		}
	}

	function hide() {
		$self.removeClass('show-message');
		$eastMessageToggleButton.attr('aria-expanded', 'false');
		$callButton.attr('tabindex', '-1');
		$learnMoreLink.attr('tabindex', '-1');
		removeTimeout();
	}

	function setElements() {
		$self = $('<div id="east-message" lang="' + userLanguage + '"><div class="message">' + text + '</div></div>');
		$eastMessageToggleButton = $('#east-message-toggle-button', $self);
		$callButton = $('#east-message-phone-number-button', $self);
		$learnMoreLink = $('#east-message-learn-more-link', $self);
		$('#main-footer').before($self); // widget ma być umieszczony przed elementami stopkwi pod kątem kolejnośći tabulowania WCAG
		if (expanded) {
			show();
			timeout = setTimeout(function() {
				hide();
			}, 10000);
		}

	}
	function initOnLoad(){
		account.onLoad(function(data){
			if(data && data.showEasternEuropeMessage === true){
				init(data.easternEuropeMessage, data.easternEuropeMessageExpanded, data.browserLanguageCode);
			}
		});
	}
	function init(t, e, l) {
		if (!isInit) {
			text = t;
			expanded = e;
			userLanguage = l || 'pl'; // z BE 'ua'|'ru'|'by' w zależności od wybranego języka
			setElements();
			setEvents();
			isInit = true;
		}
	}
	return {
		init: initOnLoad
	};
});
